import { alpha, styled } from '@mui/material';

export const Root = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fullScreen',
})<{ fullScreen?: boolean }>(({ fullScreen }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: '2rem',
  boxSizing: 'border-box',
  height: fullScreen ? '100vh' : '100%',
  minHeight: fullScreen ? '100vh' : '60vh',
}));

export const Title = styled('h1')(({ theme }) => ({
  margin: 0,
  fontSize: '1.875rem',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '110%',
  color: theme.palette.grey[950] ?? theme.palette.text.primary,
  textAlign: 'center',
  marginTop: '3rem',
  marginBottom: '1rem',
}));

export const Description = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '140%',
  color: theme.palette.grey[800],
  textAlign: 'center',
  maxWidth: '35rem',
}));

export const IconCircle = styled('div')(({ theme }) => ({
  width: '7.5rem',
  height: '7.5rem',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
}));

export const Actions = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '1rem',
  marginTop: '2rem',
});

export const DetailsContainer = styled('div')({
  marginTop: '2rem',
  width: '100%',
  maxWidth: '35rem',
  textAlign: 'left',
});

export const DetailsPre = styled('pre')({
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  fontSize: '0.75rem',
});
